function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#fff}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_420",
  d: "M106.587 119.893a1.286 1.286 0 0 0 1.259-1.03 11.6 11.6 0 0 1 11.34-9.256 11.154 11.154 0 0 1 9.4 5.143h-6.829a1.286 1.286 0 1 0 0 2.571h9a1.285 1.285 0 0 0 1.286-1.286v-9a1.286 1.286 0 0 0-2.571 0v4.627a13.638 13.638 0 0 0-10.286-4.627 14.182 14.182 0 0 0-13.86 11.315 1.287 1.287 0 0 0 1 1.516 1.246 1.246 0 0 0 .261.027z",
  className: "cls-1",
  transform: "translate(-105.3 -105.75)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_421",
  d: "M132.813 135.025a1.281 1.281 0 0 0-1.517 1 11.6 11.6 0 0 1-11.339 9.256 11.153 11.153 0 0 1-9.4-5.143h6.829a1.286 1.286 0 0 0 0-2.571h-9a1.285 1.285 0 0 0-1.286 1.286v9a1.286 1.286 0 1 0 2.571 0v-4.627a13.637 13.637 0 0 0 10.286 4.627 14.182 14.182 0 0 0 13.86-11.315 1.286 1.286 0 0 0-1.004-1.513z",
  className: "cls-1",
  transform: "translate(-106.072 -118.285)"
});

function SvgArrowRotate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_166",
    width: 27.771,
    height: 30.857,
    viewBox: "0 0 27.771 30.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRotate);
export default __webpack_public_path__ + "static/media/arrow-rotate.694257d0.svg";
export { ForwardRef as ReactComponent };